module.exports = __webpack_public_path__ + "img/map-large-3.57c4d852.jpg";